import { useEffect } from 'react';

export type LegalType = 'privacy' | 'terms' | 'children';

interface LegalModalProps {
  active: LegalType | null;
  onClose: () => void;
}

const EMAIL = 'info@mizean.com';

interface LegalSection {
  title: string;
  body: string;
}

const privacySections: LegalSection[] = [
  {
    title: '一、我们的约定',
    body: '欢迎来到 NOMOISM。我们相信，好的关系从尊重开始。这份隐私政策，是我们与你之间关于个人信息的一份约定——我们会说清楚收集了什么、用在哪里、又如何守护它。',
  },
  {
    title: '二、我们收集的信息',
    body: '1. 你主动告诉我们的事：当你订阅我们的资讯、填写表单或联系我们时，可能会留下昵称、电子邮箱、联系方式。\n2. 我们悄悄记下的足迹：为了把体验做得更好，我们会自动记录浏览器类型、设备信息、访问时间、浏览记录等匿名化数据。',
  },
  {
    title: '三、信息的用途',
    body: '我们只用你的信息做这几件事：回应你的每一次留言与咨询、把你感兴趣的产品和内容送到你面前、寄出你主动订阅的更新、以及打磨出更贴合你心意的体验。除此之外，我们不会越界。',
  },
  {
    title: '四、我们如何守护',
    body: '你的信息会依法存储在中华人民共和国境内。我们以加密传输、访问控制等一道道「门锁」，防止它被泄露、丢失或损坏。若真的发生安全事件，我们会第一时间依法告知你，并尽快补救。',
  },
  {
    title: '五、我们如何分享',
    body: '我们不卖你的信息，过去不卖，以后也不会。除非法律有要求、或得到你明确的点头，我们不会把你的信息交给任何第三方。',
  },
  {
    title: '六、你的权利',
    body: '这是你的信息，你说了算。你可以依法查阅、更正、删除你的个人信息，也可以撤回同意、注销账号。任何时候想行使这些权利，通过文末的联系方式告诉我们，我们会在十五个工作日内回应你。',
  },
  {
    title: '七、未成年人的特别关怀',
    body: '我们格外在意小朋友的信息安全。若你未满十四周岁，请在监护人的陪伴下使用我们的服务。关于儿童个人信息的更多细节，请查看专门的《儿童个人信息保护规则》。',
  },
  {
    title: '八、联系我们',
    body: '关于这份隐私政策，你若有任何疑问、建议，或只是想聊聊，都可以写信到 ' + EMAIL + '。我们会在十五个工作日内回复你。',
  },
];

const termsSections: LegalSection[] = [
  {
    title: '一、欢迎来到 NOMOISM',
    body: '你好呀。NOMOISM 想用一群从中国风土里长出来的角色，陪你度过一些温柔的日常。在开始这段旅程之前，请花几分钟读一读这份使用条款——它讲的是我们如何相处。',
  },
  {
    title: '二、你的行为，你的责任',
    body: '在这片小世界里，希望你能自在、快乐，也请遵守中华人民共和国的法律法规，不做伤害他人、破坏秩序的事。',
  },
  {
    title: '三、我们的创作，我们的守护',
    body: '这里每一个 IP 形象、每一段文字、每一张图片、每一个设计，都是 NOMOISM 和创作者们的心血，受《中华人民共和国著作权法》《中华人民共和国商标法》等法律保护。请别未经许可地复制、传播或用于商业用途。',
  },
  {
    title: '四、免责声明',
    body: '生活总有意外，网站也难免遇到不可抗力、系统维护、网络波动等小插曲。在法律允许的范围内，我们对这些情况造成的服务中断或信息误差不承担责任。',
  },
  {
    title: '五、条款的更新',
    body: '我们偶尔会完善这份条款，就像角色会慢慢长大。更新后的内容会公布在这里，你继续使用，就代表你接受了新的约定。',
  },
  {
    title: '六、法律适用与争议解决',
    body: '这份条款由中华人民共和国法律守护。若我们之间产生分歧，先坐下来好好商量；实在谈不拢，再交由有管辖权的人民法院解决。',
  },
  {
    title: '七、联系我们',
    body: '关于使用条款有任何疑问，写信到 ' + EMAIL + '，我们很乐意和你聊聊。',
  },
];

const childrenSections: LegalSection[] = [
  {
    title: '一、写给家长和小朋友的话',
    body: 'NOMOISM 欢迎每一个充满好奇心的小朋友，但我们更希望你们在安全、被保护的环境里玩耍。依据《儿童个人信息网络保护规定》等法律法规，我们特别制定了这份规则，守护十四周岁以下儿童的每一份个人信息。',
  },
  {
    title: '二、我们如何收集和使用儿童信息',
    body: '在收集、使用十四周岁以下儿童的个人信息前，我们会以清晰、易懂的方式告知监护人，并取得监护人的明确同意。我们仅收集实现服务所必需的最少信息，绝不用于其他目的。',
  },
  {
    title: '三、监护人的权利',
    body: '作为监护人，你有权查询、更正、删除孩子的个人信息，也有权随时撤回你的同意。行使这些权利，请通过 ' + EMAIL + ' 联系我们，我们会在核实监护人身份后尽快处理。',
  },
  {
    title: '四、我们如何守护儿童信息',
    body: '我们对儿童个人信息采取更严格的安全保护措施，并严格控制访问权限，确保它们只被用于向孩子提供更安全、更有趣的体验。',
  },
  {
    title: '五、联系我们',
    body: '若你发现任何可能涉及儿童个人信息的问题，或对这份规则有疑问，请立即通过 ' + EMAIL + ' 告诉我们，我们会第一时间处理。',
  },
];

const titleMap: Record<LegalType, string> = {
  privacy: '隐私政策',
  terms: '使用条款',
  children: '儿童个人信息保护规则',
};

const sectionMap: Record<LegalType, LegalSection[]> = {
  privacy: privacySections,
  terms: termsSections,
  children: childrenSections,
};

export default function LegalModal({ active, onClose }: LegalModalProps) {
  useEffect(() => {
    document.body.style.overflow = active ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [active]);

  if (!active) return null;

  const title = titleMap[active];
  const sections = sectionMap[active];

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-6"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onClick={onClose}
    >
      <div className="absolute inset-0 bg-foreground-950/50 backdrop-blur-sm"></div>

      <div
        className="relative z-10 flex max-h-[85vh] w-full max-w-2xl flex-col overflow-hidden rounded-lg bg-background-50"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-background-200 px-6 py-5">
          <h3 className="font-heading text-xl text-foreground-950">{title}</h3>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="flex h-9 w-9 items-center justify-center rounded-full text-foreground-600 transition-colors duration-300 hover:bg-background-100 hover:text-foreground-950 cursor-pointer"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>

        <div className="overflow-y-auto px-6 py-6">
          <div className="space-y-6">
            {sections.map((section) => (
              <div key={section.title}>
                <h4 className="font-heading text-base text-foreground-950">{section.title}</h4>
                <p className="mt-2 whitespace-pre-line text-sm leading-relaxed text-foreground-700">
                  {section.body}
                </p>
              </div>
            ))}

            <div className="rounded-md bg-background-100 px-4 py-4">
              <p className="text-xs leading-relaxed text-foreground-600">
                如你有任何疑问，欢迎随时联系我们：
                <a
                  href={`mailto:${EMAIL}`}
                  className="ml-1 text-primary-600 transition-colors duration-300 hover:text-primary-700 cursor-pointer"
                >
                  {EMAIL}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}